/* STRYD Instagram section: opens a post inside the page instead of sending shoppers to Instagram, 2026-10-18.
   Each tile carries its data in a <script type="application/json" class="stryd-ig__data">. The viewer shows the photo,
   the caption and every product tagged on the post, each with colour/size buttons and Add to cart (Essential Cart opens
   itself on /cart/add.js; otherwise the theme cart drawer, or the cart page). Arrows step through posts; Esc, X or a
   click outside closes it. "View on Instagram" opens in a new tab so the store stays open.
   2026-10-19: picking a colour swaps the product thumbnail to that colour's variant photo. */
(function () {
  'use strict';
  var box, current = { list: [], i: 0 }, PRODUCTS = {}, closedAt = 0;
  var MONEY = (document.querySelector('[data-ig-money]') || {}).getAttribute ? document.querySelector('[data-ig-money]').getAttribute('data-ig-money') : '${{amount}}';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(cents) { return (MONEY || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, (cents / 100).toFixed(2).replace(/\.00$/, '')); }
  function loadProduct(h) {
    if (!PRODUCTS[h]) PRODUCTS[h] = fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return PRODUCTS[h];
  }
  function isColour(o) { return /colou?r/i.test(o.name); }
  function matches(v, sel) { for (var k = 0; k < sel.length; k++) { if (sel[k] != null && v.options[k] !== sel[k]) return false; } return true; }

  function build() {
    box = document.createElement('div');
    box.className = 'stryd-igv';
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Instagram post');
    box.innerHTML =
      '<div class="stryd-igv__scrim" data-igv-close></div>' +
      '<div class="stryd-igv__card">' +
        '<button type="button" class="stryd-igv__close" data-igv-close aria-label="Close">&times;</button>' +
        '<button type="button" class="stryd-igv__nav stryd-igv__nav--prev" data-igv-prev aria-label="Previous post"><svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7"/></svg></button>' +
        '<button type="button" class="stryd-igv__nav stryd-igv__nav--next" data-igv-next aria-label="Next post"><svg viewBox="0 0 24 24"><path d="M9 5l7 7-7 7"/></svg></button>' +
        '<div class="stryd-igv__media"><img alt=""></div>' +
        '<div class="stryd-igv__body">' +
          '<p class="stryd-igv__handle"></p>' +
          '<div class="stryd-igv__text"></div>' +
          '<div class="stryd-igv__shop"></div>' +
          '<a class="stryd-igv__ig" target="_blank" rel="noopener">View on Instagram</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(box);
    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-igv-close]')) close();
      else if (e.target.closest('[data-igv-prev]')) step(-1);
      else if (e.target.closest('[data-igv-next]')) step(1);
    });
    /* any press outside the white card closes it (scrim, page edges, header), not only the X */
    document.addEventListener('pointerdown', function (e) {
      if (box.hidden || !e.isPrimary) return;
      if (!e.target.closest || !e.target.closest('.stryd-igv__card')) { e.preventDefault(); close(); closedAt = Date.now(); }
    }, true);
    /* swallow the click that follows that press so it doesn't open whatever sits underneath */
    document.addEventListener('click', function (e) {
      if (Date.now() - closedAt < 600) { e.preventDefault(); e.stopPropagation(); closedAt = 0; }
    }, true);
    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') step(-1);
      if (e.key === 'ArrowRight') step(1);
    });
  }

  function open(list, i, toShop) {
    if (!box) build();
    current = { list: list, i: i };
    show(toShop);
    box.hidden = false;
    document.documentElement.classList.add('stryd-igv-open');
    box.querySelector('.stryd-igv__close').focus();
  }
  function close() { box.hidden = true; document.documentElement.classList.remove('stryd-igv-open'); }
  function step(d) { var n = current.list.length; current.i = (current.i + d + n) % n; show(false); }

  function show(toShop) {
    var d = current.list[current.i];
    var img = box.querySelector('.stryd-igv__media img');
    img.src = d.image; img.alt = d.alt || '';
    box.querySelector('.stryd-igv__handle').textContent = '@' + (d.handle || 'strydperformance');
    box.querySelector('.stryd-igv__text').innerHTML = d.text || '';
    var ig = box.querySelector('.stryd-igv__ig'); ig.href = d.url;
    var shop = box.querySelector('.stryd-igv__shop');
    var multi = current.list.length > 1;
    box.querySelectorAll('.stryd-igv__nav').forEach(function (b) { b.hidden = !multi; });
    if (!d.products || !d.products.length) { shop.innerHTML = ''; return; }
    shop.innerHTML = '<p class="stryd-igv__shoptitle">Shop the look</p>' +
      d.products.map(function (h) { return '<div class="stryd-igv__prod" data-handle="' + esc(h) + '"><div class="stryd-igv__pimg"></div><div class="stryd-igv__pinfo"><span class="stryd-igv__pname">&nbsp;</span></div></div>'; }).join('');
    d.products.forEach(function (h) {
      loadProduct(h).then(function (p) {
        var el = shop.querySelector('[data-handle="' + CSS.escape(h) + '"]');
        if (!el) return;
        if (!p) { el.remove(); return; }
        el.querySelector('.stryd-igv__pimg').innerHTML = p.featured_image ? '<a href="' + esc(p.url || '/products/' + h) + '"><img src="' + esc(p.featured_image) + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="" loading="lazy" width="80" height="100"></a>' : '';
        el.querySelector('.stryd-igv__pinfo').innerHTML =
          '<a class="stryd-igv__pname" href="/products/' + esc(h) + '">' + esc(p.title) + '</a>' +
          '<span class="stryd-igv__price">' + money(p.price) + '</span>' +
          '<div class="stryd-igv__picker"></div>' +
          '<button type="button" class="stryd-igv__add" disabled>Loading</button>';
        picker(el, p, {});
      });
    });
    if (toShop) setTimeout(function () { shop.scrollIntoView({ block: 'start', behavior: 'smooth' }); }, 50);
  }

  function picker(el, p, sel0) {
    var opts = p.options || [];
    var sel = opts.map(function (o, k) { return sel0[k] != null ? sel0[k] : null; });
    opts.forEach(function (o, k) { if (o.values.length === 1) sel[k] = o.values[0]; });
    opts.forEach(function (o, k) {
      if (sel[k] == null && isColour(o)) { var f = p.variants.find(function (v) { return v.available; }); if (f) sel[k] = f.options[k]; }
    });
    var holder = el.querySelector('.stryd-igv__picker'), btn = el.querySelector('.stryd-igv__add');
    var hasDefault = opts.length === 1 && opts[0].values.length === 1 && /default/i.test(opts[0].values[0]);
    holder.innerHTML = hasDefault ? '' : opts.map(function (o, k) {
      if (o.values.length === 1) return '<div class="stryd-igv__opt"><span class="stryd-igv__optname">' + esc(o.name) + ': ' + esc(o.values[0]) + '</span></div>';
      return '<div class="stryd-igv__opt"><span class="stryd-igv__optname">' + esc(o.name) + (sel[k] ? ': ' + esc(sel[k]) : '') + '</span><div class="stryd-igv__chips">' +
        o.values.map(function (val) {
          var trial = sel.slice(); trial[k] = val;
          var ok = p.variants.some(function (v) { return v.available && matches(v, trial); });
          var on = sel[k] === val;
          return '<button type="button" class="stryd-igv__chip' + (on ? ' is-on' : '') + (ok ? '' : ' is-out') + '" data-k="' + k + '" data-v="' + esc(val) + '" aria-pressed="' + on + '"' + (ok ? '' : ' aria-disabled="true"') + '>' + esc(val) + '</button>';
        }).join('') + '</div></div>';
    }).join('');
    holder.querySelectorAll('.stryd-igv__chip').forEach(function (c) {
      c.addEventListener('click', function () {
        if (c.classList.contains('is-out')) return;
        var k = +c.getAttribute('data-k'), val = c.getAttribute('data-v');
        sel[k] = (sel[k] === val && !isColour(opts[k])) ? null : val;
        if (!p.variants.some(function (v) { return v.available && matches(v, sel); })) {
          opts.forEach(function (o, j) { if (j !== k && o.values.length > 1) sel[j] = null; });
        }
        picker(el, p, sel);
      });
    });
    var complete = sel.every(function (x) { return x != null; });
    var variant = complete ? p.variants.find(function (v) { return v.available && matches(v, sel); }) : null;
    var anyStock = p.variants.some(function (v) { return v.available; });
    var missing = opts.filter(function (o, k) { return sel[k] == null; }).map(function (o) { return o.name.toLowerCase(); });
    /* show the photo of the chosen colour (each colour variant carries its own image) */
    var ci = -1;
    opts.forEach(function (o, k) { if (ci < 0 && isColour(o)) ci = k; });
    if (ci > -1 && sel[ci] != null) {
      var cv = variant && variant.featured_image ? variant : p.variants.find(function (v) { return v.options[ci] === sel[ci] && v.featured_image; });
      var pimg = el.querySelector('.stryd-igv__pimg img'), plink = el.querySelector('.stryd-igv__pimg a');
      if (cv && pimg) {
        var src = cv.featured_image.src, want = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=200';
        if (pimg.getAttribute('src') !== want) { pimg.src = want; pimg.alt = sel[ci]; }
        if (plink) plink.href = (p.url || '/products/' + p.handle) + '?variant=' + cv.id;
      }
    }
    btn.disabled = !variant;
    btn.textContent = !anyStock ? 'Sold out' : variant ? 'Add to cart' : 'Select ' + (missing[0] || 'an option');
    btn.onclick = variant ? function () { add(variant.id, btn); } : null;
  }

  function add(id, btn) {
    btn.disabled = true; btn.textContent = 'Adding';
    var dawn = document.querySelector('cart-drawer');
    var body = { items: [{ id: id, quantity: 1 }] };
    if (dawn && typeof dawn.getSectionsToRender === 'function') {
      body.sections = dawn.getSectionsToRender().map(function (x) { return x.id; });
      body.sections_url = location.pathname;
    }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) { btn.disabled = false; btn.textContent = 'Try again'; return; }
        close();
        setTimeout(function () {
          if (document.documentElement.className.indexOf('essential-cart__open') > -1) return;
          if (dawn && typeof dawn.renderContents === 'function' && res.json.sections) { dawn.classList.remove('is-empty'); dawn.renderContents(res.json); }
          else { location.href = '/cart'; }
        }, 900);
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Try again'; });
  }

  /* wire up every STRYD Instagram section on the page */
  function init() {
    document.querySelectorAll('.stryd-ig').forEach(function (sec) {
      if (sec.hasAttribute('data-igv')) return;
      sec.setAttribute('data-igv', '');
      var tiles = [].slice.call(sec.querySelectorAll('.stryd-ig__tile'));
      var list = tiles.map(function (t) { try { return JSON.parse(t.querySelector('.stryd-ig__data').textContent); } catch (e) { return null; } });
      tiles.forEach(function (t, i) {
        if (!list[i]) return;
        var openBtn = t.querySelector('.stryd-ig__post'), shopBtn = t.querySelector('.stryd-ig__shop');
        if (openBtn) openBtn.addEventListener('click', function (e) { e.preventDefault(); open(list, i, false); });
        if (shopBtn) shopBtn.addEventListener('click', function (e) { e.preventDefault(); open(list, i, true); });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
